// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__AZoxK","logo-container":"Nav_logo-container__g40Bf","links-container":"Nav_links-container__PjGuL","link":"Nav_link__rPZ4g"};